import React from 'react';
import LegalLayout, { LegalH2, LegalH3, LegalP, LegalUl } from './LegalLayout';

const Terminos = () => (
  <LegalLayout
    title="Términos y condiciones de contratación"
    subtitle="Condiciones generales que rigen la compra de formaciones y la suscripción al Campus de Interioridad."
    lastUpdate="Abril 2026"
  >
    <LegalH2 id="identificacion">1. Quién ofrece el servicio</LegalH2>
    <LegalUl>
      <li><strong>Titular:</strong> Herminio Vázquez Vigón (autónomo persona física)</li>
      <li><strong>NIF:</strong> se facilita de forma privada ante solicitud fundada</li>
      <li><strong>Domicilio profesional:</strong> Barcelona (España)</li>
      <li><strong>Email de contacto:</strong> <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a></li>
    </LegalUl>

    <LegalH2 id="objeto">2. Objeto</LegalH2>
    <LegalP>
      Las presentes condiciones regulan la contratación a distancia de los productos y servicios digitales ofrecidos en el Sitio, incluyendo:
    </LegalP>
    <LegalUl>
      <li><strong>Formaciones individuales:</strong> cursos online con precio cerrado, acceso online al material y, cuando se indique, sesiones en directo.</li>
      <li><strong>Suscripción al Campus de Interioridad:</strong> acceso a una biblioteca de contenidos y espacios vivos de la escuela mediante una cuota mensual o anual, renovable automáticamente.</li>
      <li><strong>Otros recursos digitales</strong> que puedan ofrecerse puntualmente (ebooks, programas especiales, viajes o encuentros, según sus propias condiciones).</li>
    </LegalUl>
    <LegalP>
      Al finalizar el proceso de compra, la persona usuaria declara haber leído, entendido y aceptado estas condiciones, junto con la Política de Privacidad y el Aviso Legal.
    </LegalP>

    <LegalH2 id="proceso">3. Proceso de contratación</LegalH2>
    <LegalP>
      La contratación se realiza íntegramente online, en castellano, siguiendo estos pasos:
    </LegalP>
    <LegalUl>
      <li>Elegir la formación o el plan de suscripción.</li>
      <li>Crear una cuenta o iniciar sesión.</li>
      <li>Revisar en pantalla el resumen del pedido: producto, precio total (IVA incluido cuando aplique) y condiciones aplicables.</li>
      <li>Aceptar las presentes Condiciones y la Política de Privacidad mediante casilla específica.</li>
      <li>Completar el pago a través de PayPal o de los medios habilitados en cada momento.</li>
      <li>Recibir confirmación por email con el acceso al contenido y la factura correspondiente.</li>
    </LegalUl>
    <LegalP>
      El contrato queda perfeccionado en el momento en que se recibe la confirmación del pago. Puedes solicitar copia del contrato en cualquier momento escribiendo a <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a>.
    </LegalP>

    <LegalH2 id="precios">4. Precios e impuestos</LegalH2>
    <LegalP>
      Los precios se muestran en euros (€), con el IVA español (21%) incluido salvo que expresamente se indique otra cosa en la ficha del producto. El importe total definitivo, incluyendo impuestos y cualquier gasto aplicable, se muestra antes de confirmar el pago. No existen costes ocultos.
    </LegalP>
    <LegalP>
      Tras completar la compra, se emite automáticamente una factura a nombre de la persona compradora con los datos que facilite. Si necesitas modificarla, escríbenos dentro de los 7 días siguientes a la compra.
    </LegalP>

    <LegalH2 id="pago">5. Medios de pago</LegalH2>
    <LegalP>
      Los pagos se gestionan a través de PayPal, que permite pagar con cuenta PayPal o con tarjeta de crédito/débito sin necesidad de tener una cuenta. El titular no almacena los datos completos de la tarjeta en ningún caso. En la Política de Privacidad se detalla la relación con PayPal como encargado de pago.
    </LegalP>

    <LegalH2 id="acceso">6. Acceso al contenido</LegalH2>
    <LegalP>
      Tras la confirmación del pago, la persona usuaria recibe acceso al contenido a través de su cuenta en el Sitio. Salvo que se indique expresamente una duración distinta:
    </LegalP>
    <LegalUl>
      <li><strong>Formaciones individuales:</strong> el acceso se mantiene mientras la escuela mantenga activa la formación en su catálogo, garantizando un período mínimo de 12 meses desde la compra.</li>
      <li><strong>Campus de Interioridad:</strong> el acceso se mantiene mientras la suscripción esté activa.</li>
    </LegalUl>
    <LegalP>
      El acceso es personal e intransferible. No se permite compartir credenciales con terceras personas; si se detecta un uso compartido abusivo, el titular podrá suspender el acceso informando previamente a la persona usuaria.
    </LegalP>

    <LegalH2 id="suscripcion-campus">7. Campus de Interioridad: suscripción con renovación automática</LegalH2>
    <LegalP>
      El Campus se ofrece como suscripción recurrente. Al contratarla, la persona usuaria autoriza expresamente los cargos periódicos correspondientes al plan elegido, según las siguientes reglas:
    </LegalP>
    <LegalUl>
      <li><strong>Plan mensual:</strong> renovación cada mes natural desde la fecha del primer cargo.</li>
      <li><strong>Plan anual:</strong> renovación cada 12 meses desde la fecha del primer cargo.</li>
      <li>El importe aplicable en cada renovación es el vigente en la página de precios en el momento de la renovación. Si hay una subida, se comunicará con al menos 30 días de antelación y permitirá cancelar antes del siguiente cargo.</li>
      <li>La renovación se carga a través de PayPal de forma automática sin necesidad de intervención de la persona usuaria.</li>
    </LegalUl>

    <LegalH3>Cómo cancelar la renovación</LegalH3>
    <LegalUl>
      <li>Desde tu área privada, en la sección de suscripción, desactivando la renovación automática.</li>
      <li>O enviando un email a <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a> antes de la fecha de la siguiente renovación.</li>
    </LegalUl>
    <LegalP>
      Al cancelar, seguirás teniendo acceso hasta el final del período ya pagado. No se realizan reembolsos parciales de períodos ya facturados, salvo obligación legal o aplicación del derecho de desistimiento explicado más abajo.
    </LegalP>

    <LegalH2 id="desistimiento">8. Derecho de desistimiento</LegalH2>
    <LegalP>
      Como persona consumidora con residencia en la Unión Europea, dispones de un plazo de 14 días naturales desde la compra para desistir del contrato sin necesidad de justificarlo, conforme al Real Decreto Legislativo 1/2007 (TRLGDCU). Este derecho se aplica tanto a las formaciones como a la primera cuota de suscripción al Campus.
    </LegalP>

    <LegalH3>Excepción aplicable a contenidos digitales</LegalH3>
    <LegalP>
      Conforme al artículo 103.m del TRLGDCU, el derecho de desistimiento no se aplica al suministro de contenidos digitales no prestados en un soporte material cuando la ejecución haya comenzado con el consentimiento previo y expreso de la persona consumidora, que además reconozca que pierde su derecho de desistimiento al iniciarse el suministro.
    </LegalP>
    <LegalP>
      En la práctica: si accedes al contenido del curso o del Campus antes de que transcurran los 14 días, y has aceptado expresamente durante la compra ejecutar el servicio de forma inmediata, el derecho de desistimiento quedará extinguido. La web te recordará este punto antes de confirmar el pago para que puedas decidir libremente.
    </LegalP>

    <LegalH3>Política comercial adicional de devolución ("satisfacción 14 días")</LegalH3>
    <LegalP>
      Con independencia de la excepción anterior, el titular ofrece por buena fe una garantía comercial voluntaria: si durante los 14 días siguientes a la compra consideras que la formación o la primera cuota del Campus no es para ti, puedes solicitar la devolución del importe escribiendo a <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a> desde el email de la cuenta, y se procesará el reembolso íntegro.
    </LegalP>
    <LegalP>
      Esta garantía comercial se ofrece para la primera compra de cada producto o para la primera cuota de suscripción. No aplica a renovaciones sucesivas ni a productos adquiridos previamente sobre los que ya se haya usado esta garantía.
    </LegalP>

    <LegalH3>Cómo ejercer el desistimiento legal</LegalH3>
    <LegalP>
      Para ejercer el desistimiento legal basta con enviar un email a <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a> con el asunto "Desistimiento" indicando nombre, email de la cuenta y producto. Puedes usar, opcionalmente, el siguiente modelo:
    </LegalP>
    <div className="my-4 p-5 rounded-lg bg-[#faf6ed] border border-[#e8e0d0] text-[14px] leading-[1.7] font-sans">
      <p>A la atención de Herminio Vázquez Vigón, con domicilio en Barcelona (España) y email hola@herminiovazquez.com:</p>
      <p className="mt-2">Por la presente le comunico que desisto del contrato celebrado para la prestación del siguiente servicio: [nombre del curso / suscripción].</p>
      <p className="mt-2">Fecha de contratación: [____]. Nombre de la persona consumidora: [____]. Email de la cuenta: [____]. Fecha: [____].</p>
    </div>
    <LegalP>
      Una vez recibido, reembolsaremos todos los pagos recibidos, sin demoras indebidas y, en todo caso, a más tardar en 14 días naturales desde que nos informes de tu decisión. El reembolso se realizará por el mismo medio de pago utilizado.
    </LegalP>
    <LegalP>
      <a href="/desistimiento" className="text-[#c9a227] hover:underline font-medium">
        → Descargar el formulario de desistimiento en PDF
      </a>
    </LegalP>

    <LegalH2 id="soporte">9. Soporte y resolución de incidencias</LegalH2>
    <LegalP>
      Si tienes cualquier problema con el acceso, con el contenido o con la facturación, escríbenos a <a href="mailto:hola@herminiovazquez.com" className="text-[#c9a227] hover:underline">hola@herminiovazquez.com</a>. Responderemos en un plazo razonable, habitualmente en 2 a 5 días laborables.
    </LegalP>

    <LegalH2 id="propiedad">10. Propiedad intelectual</LegalH2>
    <LegalP>
      Todos los contenidos de las formaciones y del Campus (vídeos, audios, textos, ejercicios, meditaciones, diseños, materiales descargables) son propiedad del titular o de sus licenciantes. La compra concede una licencia de uso personal, no exclusiva, no transferible y limitada al acceso a través del Sitio.
    </LegalP>
    <LegalP>
      Queda prohibido descargar, grabar, difundir, revender, publicar o poner a disposición de terceros los contenidos, total o parcialmente, por cualquier medio. El incumplimiento facultará al titular a suspender el acceso y a ejercer las acciones legales oportunas.
    </LegalP>

    <LegalH2 id="responsabilidad">11. Limitación de responsabilidad</LegalH2>
    <LegalP>
      Los contenidos tienen finalidad formativa y de acompañamiento al trabajo personal. No sustituyen el consejo médico, psicológico, terapéutico, legal o financiero. La persona usuaria es responsable del uso que haga de ellos y de las decisiones que tome a partir de los mismos.
    </LegalP>
    <LegalP>
      El titular responde únicamente por los daños previsibles, ciertos y directamente imputables a una mala ejecución del servicio, conforme a la normativa de protección de personas consumidoras. No responde de interrupciones puntuales del servicio por causas técnicas, de fuerza mayor o imputables a terceros proveedores.
    </LegalP>

    <LegalH2 id="modificaciones">12. Modificación de estas condiciones</LegalH2>
    <LegalP>
      El titular podrá actualizar estas condiciones por razones operativas, legales o de mejora del servicio. La versión vigente se mostrará siempre en esta página con fecha de última actualización. Los cambios sustanciales que afecten a contratos ya vigentes se notificarán por email.
    </LegalP>

    <LegalH2 id="ley">13. Ley aplicable y resolución de controversias</LegalH2>
    <LegalP>
      Las presentes condiciones se rigen por la legislación española. Para la resolución de controversias, las partes se someten a los Juzgados y Tribunales de Barcelona, sin perjuicio del fuero que corresponda a las personas consumidoras por normativa imperativa.
    </LegalP>
    <LegalP>
      Si eres persona consumidora residente en la Unión Europea, puedes acudir a la plataforma europea de resolución de litigios en línea: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#c9a227] hover:underline">https://ec.europa.eu/consumers/odr</a>.
    </LegalP>
  </LegalLayout>
);

export default Terminos;
